import React from 'react'
import Header from '../Header/Header'
import "./Home.css"
import { AiOutlineDownCircle } from 'react-icons/ai'
import { HashLink as  Link } from 'react-router-hash-link'
import About from '../About/About'
import Work from '../Work/Work'
import Contact from '../Contact/Contact'
function Home() {
    return (
        <>
            <Header />
            <div id="home">
                <div className="content">
                <animate attributeName="d" from="m0,110 h0" to="m0,110 h1100" dur="6.8s" begin="0s" repeatCount="indefinite"/>
                    <h2>I am Ankit Chotaliya...</h2>
                    <h3>Web developer & UI/Ux desinger <span>|</span></h3>
                    
                </div>
                <div className="icon">
                    <Link to="/#about-page"><AiOutlineDownCircle className="icon2" /></Link>
                </div>

            </div>
            <About/>
            <Work/>
            <Contact/>
        </>
    )
}

export default Home
